import gql from 'graphql-tag';
const GET_USER = gql`
  mutation getDashboardUser($username: String!) {
    getDashboardUser(username: $username)
  }
`;

export default GET_USER;
